import { createContext, useContext, useMemo, useState } from 'react';

const SpeechChannelContext = createContext(null);

export function SpeechChannelProvider({ children }) {
  const [activeId, setActiveId] = useState(null);
  const value = useMemo(() => ({ activeId, setActiveId }), [activeId]);
  return <SpeechChannelContext.Provider value={value}>{children}</SpeechChannelContext.Provider>;
}

export function useSpeechChannel() {
  const ctx = useContext(SpeechChannelContext);
  if (!ctx) throw new Error('useSpeechChannel must be used within SpeechChannelProvider');
  return ctx;
}
